import ProductsSlider from "@/components/features/products/productsSlider/ProductsSlider";
import { ProductCategoryName, type Product } from "@/types/products";

interface CategoryProductsProps {
  productsByCategory: Record<ProductCategoryName, Product[]> | null;
  isLoadingProducts: boolean;
}

const CategoryProducts = ({ productsByCategory, isLoadingProducts }: CategoryProductsProps) => {
  return (
    <>
      <h2 className="brand-heading-lg text-left text-accent">依風味調性選擇</h2>
      <h3 className="brand-heading-md mt-3 text-left text-base-content lg:mt-6">花香水果調</h3>
      <p className="lg:text-md mb-6 mt-3 max-w-xs pr-8 text-left text-sm leading-relaxed text-base-content lg:max-w-lg">
        清新明亮的香氣，帶有花香與果香的酸甜感，口感輕盈而富有層次，適合喜歡清爽、活潑風味的您。
      </p>

      <ProductsSlider
        products={productsByCategory?.[ProductCategoryName.FloralFruity] || []}
        isLoading={isLoadingProducts}
      />
      <hr className="mt-6 border-black" />

      <h3 className="brand-heading-md mt-6 text-left text-base-content lg:mt-9">堅果調</h3>
      <p className="lg:text-md mb-6 mt-3 max-w-xs pr-8 text-left text-sm leading-relaxed text-base-content lg:max-w-lg">
        醇厚溫潤的口感，帶有堅果、巧克力與烘焙的香氣，滋味厚實而順口。適合喜歡濃郁、飽滿風味的您，入口圓潤滑順，餘韻綿長。
      </p>
      <ProductsSlider
        products={productsByCategory?.[ProductCategoryName.Nutty] || []}
        isLoading={isLoadingProducts}
      />
      <hr className="mt-9 border-black" />
    </>
  );
};

export default CategoryProducts;
